/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ENABLE_BOLTIVE, shouldLoadBoltiveTag } from '../actions/boltiveActions';

const initialState = {
    shouldLoadBoltiveTag: false
};

export function boltive(state = initialState, action: ReturnType<typeof shouldLoadBoltiveTag>)
{
    switch (action.type)
    {
        case ENABLE_BOLTIVE:
        {
            return {
                ...state,
                shouldLoadBoltiveTag: action.payload
            };
        }

        default: {
            return state;
        }
    }
}

